import Typography from "@mui/material/Typography";
// import styles from "../devotee.module.scss";
import styles from "./creditcardpayment.module.scss";
import commonStyles from "../../../App.module.scss";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { ClipLoader } from "react-spinners";
import axios, { AxiosResponse, AxiosError } from "axios";
import { Box, Grid, IconButton, InputAdornment, styled } from "@mui/material";
import { useState, useRef, useEffect, ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import apiPath from "../../../config/apiPaths.json";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { object, string, ValidationError } from "yup";
import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
  getUserName,
} from "../../../infrastructure/backendService";
import {
  CustomSelect,
  CustomMenuItem,
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarTodayOutlinedIcon,
  CustomLeftIcon,
  CustomRequiredInputLabel,
  CustomTextFeild,
  CommonButton,
  HcccCard,
  CommonOutlinedButton,
  CustomCityStateTextField,
} from "../../common/StyledComponents/StyledFields";
import { useSearchParams } from "react-router-dom";
import ToastError from "../../common/toast/toastError";
import SuccessComponent from "../../volunteerRegistration/successComponent/successComponent";
import { isNil } from "lodash";
import SuccessPopup from "./successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import constants from "../../../config/constants.json";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import { CustomTooltip } from "../../common/muhurtham/muhurtham";
import { RoutingURLs, SubRoutingURLs } from "../../common/RoutingURLs";
import PaymentCancelConfirmationDialog from "../../PaymentCancelConfirmation/PaymentCancelConfirmation";

function debounce<T extends Function>(cb: T, wait = 750) {
  let h: any = 0;
  let callable = (...args: any) => {
    clearTimeout(h);
    h = setTimeout(() => cb(...args), wait);
  };
  return callable;
}

export interface unRegisteredUserDetailsProps {
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  email: string;
  amount: string;
}
interface CreditCardsProps {
  setSelectedPaymentMode?: React.Dispatch<React.SetStateAction<string>>;
  amount?: string;
  devoteeType?: boolean | undefined;
  userDetails?: unRegisteredUserDetailsProps | null;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  navigateBack?: () => void;
}

interface CreditCardErrorMessageTypes {
  expiryDate: string;
  creditCardNumber: string;
  cvv: string;
  amount: string;
  creditCardType: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  address: string;
}

const CreditTypeInfo = [
  {
    type: "Visa",
  },
  {
    type: "Master Card",
  },
  {
    type: "Discover",
  },
  {
    type: "Amex",
  },
  {
    type: "American Express",
  },
];

export default function CreditCardPayment(props: CreditCardsProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showSuccessComponent, setShowSuccessComponent] =
    useState<boolean>(false);
  const [searchParam] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [receiptID, setReceiptID] = useState<string>("");
  const [showReceipt, setShowReceipt] = useState<boolean>(false);
  const [userID, setUserID] = useState<string>("");
  const [formattedCreditCard, setFormattedCreditCard] = useState<string>("");
  const [creditCardUserData, setCreditUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userAddress: "",
    city: "",
    state: "",
    zipcode: "",
    country: "USA",
    phoneNumber: "",
  });

  const [creditCardUserUpdatedData, setCreditUserUpdatedData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    address: "",
    amount: "",
  });

  const [errorMessage, setErrorMessage] = useState<CreditCardErrorMessageTypes>(
    {
      expiryDate: "",
      creditCardNumber: "",
      cvv: "",
      amount: "",
      creditCardType: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      address: "",
    }
  );
  const status = searchParam.get("status");
  const amountPopulated = searchParam.get("amount");
  const donationPurposeId = sessionStorage.getItem("donationPurposeID");
  const accountDescription = sessionStorage.getItem("accountDescription");
  const [name, setName] = useState<string>("");
  const [expiry, setExpiry] = useState<string>("");
  const [cardNumber, setCardNumber] = useState<string>("");
  const cardRef = useRef<any>();
  const donationType = searchParam.get("donationType");
  var apiUrl = "";
  const [itemsList, setItemList] = useState<any[]>([]);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [cvvText, setCVVtext] = useState(true);

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  useEffect(() => {
    const storedCartItems = sessionStorage.getItem("cartItems");
    if (storedCartItems) {
      const cartItemObjects = JSON.parse(storedCartItems);
      setItemList(cartItemObjects);
    }
  }, []);

  useEffect(() => {
    if (isNil(props.userDetails)) {
      apiRequest({
        method: "GET",
        endpoint: `${
          apiPath.getDevoteeDetails
        }/${getUserName()?.toUpperCase()}`,
        includeToken: true,
      })
        .then((res) => {
          setCreditUserData({
            ...creditCardUserData,
            firstName: res.data.firstname,
            lastName: res.data.lastname,
            userAddress: res.data.address,
            city: res.data.city,
            state: res.data.state,
            zipcode: res.data.zipcode,
            country: "USA",
            email: res.data.email,
            phoneNumber: res.data.phoneNumber,
          });
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            <ErrorPopup
              showMessage={catchErrorMessageHandler(err)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        });
    } else {
      setCreditUserData({
        ...creditCardUserData,
        firstName: props.userDetails.firstName,
        lastName: props.userDetails.lastName,
        userAddress: props.userDetails.address,
        city: props.userDetails.city,
        state: props.userDetails.state,
        zipcode: props.userDetails.zipcode,
        country: "USA",
        email: props.userDetails.email,
      });
    }
  }, []);

  const handleSave = async (): Promise<void> => {
    const errors = {
      expiryDate: "",
      creditCardNumber: "",
      cvv: "",
      amount: "",
      creditCardType: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      address: "",
    };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      await UserdetailsValidationSchema.validate(creditCardUserUpdatedData, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      saveApiCall();
    } catch (error: any) {
      // Handle validation errors
      if (error instanceof ValidationError) {
        error.inner.forEach((e: ValidationError) => {
          if (e.path) {
            // Check which schema the error belongs to and set the error message accordingly
            if (Object.keys(validationSchema.fields).includes(e.path)) {
              errors[e.path as keyof CreditCardErrorMessageTypes] = e.message;
            } else if (
              Object.keys(UserdetailsValidationSchema.fields).includes(e.path)
            ) {
              errors[e.path as keyof CreditCardErrorMessageTypes] = e.message;
            }
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const detectCardType = (_cardNumber: string): string => {
    if (/^4/.test(_cardNumber)) {
      return "Visa";
    } else if (/^5[1-5]/.test(_cardNumber)) {
      return "Master Card";
    } else if (/^6(?:011|5[0-9]{2})/.test(_cardNumber)) {
      return "Discover";
    } else if (/^3[47]/.test(_cardNumber)) {
      return "Amex";
    } else if (_cardNumber.length === 15) {
      return "American Express";
    } else {
      return ""; // Unknown card type
    }
  };

  const parseCardDetails = (value: string) => {
    // var document = Document;
    // const cardInput1 = document?.getElementById('cardvalue') as HTMLInputElement;
    // console.log(cardInput1.value,"card");
    // const cardValue = cardInput1.value;
    const regex = /.*?(\d{15,16})=(\d{2})(\d{2}).*?/;

    const nameRegex = /(?:[^\^]+)\^([^\^]+)\^/;

    const namematch = value?.match(nameRegex);
    if (namematch !== null) {
      let cardName = namematch[1].replace(/\/$/, "");
      if (cardName.includes("/")) {
        const nameParts = cardName.split("/");
        cardName = nameParts.reverse().join(" ");
      }
      setName(cardName);
    } else {
      setName("");
    }

    const match = value?.match(regex);
    if (match) {
      const _cardNumber = match[1];
      const expiryYear = match[2];
      const expiryMonth = match[3];

      setExpiry(`${expiryMonth}/${expiryYear}`);
      setCardNumber(_cardNumber);

      // const cardType = detectCardType(_cardNumber);

      setFormData({
        ...formData,
        expiryDate: `${expiryMonth}/${expiryYear}`,
        creditCardNumber: _cardNumber,
        creditCardType: detectCardType(_cardNumber),
      });
      cardRef.current.value = _cardNumber;
    } else {
      setFormData({
        ...formData,
        creditCardNumber: cardRef?.current?.value,
        creditCardType: detectCardType(cardRef?.current?.value),
      });
    }
  };

  const getAmount = () => {
    if (isNil(props.amount)) {
      return amountPopulated;
    } else {
      return props.amount;
    }
  };

  const validationSchema = object().shape({
    expiryDate: string().required("Expiry Date is required"),
    creditCardType: string().required("Credit Card Type is required"),
    creditCardNumber: string().required("Credit Card Number is required"),
    cvv: string().required("CVV is required"),
    // amount: string().required('Amount is required'),
  });

  const UserdetailsValidationSchema = object().shape({
    firstName: string().required("First Name is required"),
    lastName: string().required("Last Name is required"),
    // email: string().required("Email is required"),
    city: string().required("city is required"),
    state: string().required("state is required"),
    zipcode: string().required("zipcode is required"),
    address: string().required("address is required"),
    country: string().required("Country is required"),
  });

  const [formData, setFormData] = useState({
    expiryDate: "",
    creditCardNumber: "",
    cvv: "",
    amount: "",
    creditCardType: "",
  });

  const handleFieldChange = (field: string, value: any) => {
    if (field === "expiryDate") {
      const formattedDate = dayjs(value, "MM/YY");

      setFormData({
        ...formData,
        [field]: formattedDate.isValid() ? formattedDate.format("MM/YY") : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.expiryDate]);

  const CreditCardTypeDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%", marginTop: "5px" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="creditCardType"
          placeholder="Select Type"
          value={formData.creditCardType}
          readOnly={true}
          onChange={(e) => {
            setErrorMessage({ ...errorMessage, creditCardType: "" });
            handleFieldChange("creditCardType", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.creditCardType
              ? styles.errorTextField
              : styles.dropdownStyle
          }
        >
          {CreditTypeInfo.map((item, index: number) => (
            <CustomMenuItem key={index} value={item.type}>
              {item.type}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.creditCardType ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.creditCardType}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  switch (donationType) {
    case "bookPooja":
      apiUrl = apiPath.cartPayment;
      break;
    case "P":
      apiUrl = apiPath.RequestedPoojaBookingPayment;
      break;
    case "E":
      apiUrl = apiPath.DevoteeHallBookingPaymentProcess;
      break;
    default:
      apiUrl =
        authService.isAuthenticated() && isNil(props.userDetails)
          ? apiPath.makePayment
          : apiPath.makePaymentUnRegistered;
  }

  const saveApiCall = async () => {
    const reqBody = {
      creditCardDetails: {
        firstName: creditCardUserUpdatedData.firstName,
        lastName: creditCardUserUpdatedData.lastName,
        userAddress: creditCardUserUpdatedData.address,
        city: creditCardUserUpdatedData.city,
        state: creditCardUserUpdatedData.state,
        zipCode: creditCardUserUpdatedData.zipcode,
        country: creditCardUserUpdatedData.country,
        cardNumber: formData.creditCardNumber,
        email: creditCardUserUpdatedData.email,
        cvv: formData.cvv,
        expirationDate: formData.expiryDate,
        amount: getAmount(),
      },
      items: itemsList,
      modeOfPayment: 20,
    };

    const contractFormReqBody = {
      creditCardDetails: {
        firstName: creditCardUserUpdatedData.firstName,
        lastName: creditCardUserUpdatedData.lastName,
        userAddress: creditCardUserUpdatedData.address,
        city: creditCardUserUpdatedData.city,
        state: creditCardUserUpdatedData.state,
        zipCode: creditCardUserUpdatedData.zipcode,
        country: creditCardUserUpdatedData.country,
        cardNumber: formData.creditCardNumber,
        email: creditCardUserUpdatedData.email,
        cvv: formData.cvv,
        expirationDate: formData.expiryDate,
        amount: getAmount(),
      },
      items: itemsList,
      modeOfPayment: 20,
      contractFormPayment: true,
    };

    setLoading(true);

    try {
      const res = await apiRequest({
        method: "POST",
        endpoint: apiUrl,
        body:
          status !== "undefined"
            ? JSON.stringify(contractFormReqBody)
            : JSON.stringify(reqBody),
        includeToken:
          !authService.isAuthenticated() && !isNil(props.userDetails)
            ? false
            : true,
      });
      // props?.setIsOpen?.(false);
      setShowSuccessComponent(true);
      // feildsConatiner();
      setReceiptID(res.data.receiptId);
      setUserID(res.data.userId);
      sessionStorage.removeItem("cartItems");
      setFormData({
        expiryDate: "",
        creditCardNumber: "",
        cvv: "",
        amount: "",
        creditCardType: "",
      });
      window.scroll(0, 200)
      props?.setIsOpen?.(false);
      sessionStorage.setItem("showPaymentStatus", JSON.stringify(true));
      navigate(`/receipt?receiptID=${res.data.receiptId}&userID=${res.data.userId}`);
      if (!authService.isAuthenticated()) {
        navigate(0);
      }
    } catch (err: any) {
      console.error(err);
      toast.custom(
        <ErrorPopup
          showMessage={catchErrorMessageHandler(err)}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  const navigateBack = () => {
    if (props && !authService.isAuthenticated()) {
      props.setSelectedPaymentMode?.("");
    } else if (props?.devoteeType && authService.isAuthenticated()) {
      props.setSelectedPaymentMode?.("");
    } else if (donationType === "bookPooja") {
      navigate(`/devoteebooking/${SubRoutingURLs.POOJA_BOOKING_REQUEST}`);
    } else if (donationType === "requestedPoojaBooking") {
      navigate(RoutingURLs.dashboard);
    } else {
      navigate(-1);
    }
  };

  const [openPaymentCancelDialog, setOpenPaymentCancelDialog] = useState(false);

  const handleClose = () => {
    setOpenPaymentCancelDialog(false);
  };

  const handleCancel = () => {
    setOpenPaymentCancelDialog(false);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setTimeout(() => {
      navigateBack();
    }, 0);
  };

  const handleButtons = () => {
    return (
      <div className={styles.buttonsContainer}>
        <CommonOutlinedButton
          onClick={() => setOpenPaymentCancelDialog(true)}
          id="cancel"
        >
          Cancel
        </CommonOutlinedButton>
        <CommonButton
          className={commonStyles.saveButton}
          onClick={handleSave}
          disabled={loading}
          id="makePayment"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Loading...
              </span>
            </>
          ) : (
            "Make Payment"
          )}
        </CommonButton>
      </div>
    );
  };

  const ExpiryDatePicker = (): React.ReactElement => {
    return (
      <div style={{ borderRadius: "8px", marginTop: "7px" }}>
        <StyledDateContainer
        id="expiryDate"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          // onClick={handleDatePickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                // open={isDatePickerOpen}
                // onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                disablePast
                format="MM/YY"
                value={
                  formData.expiryDate ? dayjs(formData.expiryDate, "MM/YY") : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, expiryDate: "" });
                  handleFieldChange("expiryDate", value);
                }}
                className={
                  errorMessage.expiryDate
                    ? styles.errorDateFeild
                    : styles.dateFeild
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.expiryDate ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.expiryDate}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const CreditCardUserDetails = () => {
    return (
      <div
        style={{ padding: "10px 25px", gap: "8px" }}
        className={styles.detailsContainer}
      >
        <Typography className={styles.deafult} style={{ marginBottom: "47px" }}>
          Default Address
        </Typography>
        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("First Name", true)}
          <CustomTextFeild
            id="firstName"
            className={styles.textField}
            fullWidth
            required
            InputProps={{
              readOnly: true,
            }}
            value={creditCardUserData.firstName}
          />
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Last Name", true)}
          <CustomTextFeild
            id="lastName"
            className={styles.textField}
            fullWidth
            required
            InputProps={{
              readOnly: true,
            }}
            value={creditCardUserData.lastName}
          />
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Address", false)}
          <CustomTextFeild
            id="address"
            className={styles.textField}
            fullWidth
            required
            InputProps={{
              readOnly: true,
            }}
            value={creditCardUserData.userAddress}
          />
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Zip Code", true)}
          <CustomTextFeild
            id="zipCode"
            className={styles.textField}
            fullWidth
            required
            value={creditCardUserData.zipcode}
            InputProps={{
              readOnly: true,
            }}
          />
        </div>
        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("City", true)}
          <CustomCityStateTextField
            id="city"
            className={styles.textField}
            fullWidth
            required
            value={creditCardUserData.city}
            InputProps={{
              readOnly: true,
            }}
          />
        </div>
        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("State", true)}
          <CustomCityStateTextField
            id="state"
            className={styles.textField}
            fullWidth
            required
            value={creditCardUserData.state}
            InputProps={{
              readOnly: true,
            }}
          />
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Country", false)}
          <CustomTextFeild
            id="country"
            className={styles.textField}
            fullWidth
            required
            InputProps={{
              readOnly: true,
            }}
            value={creditCardUserData.country}
          />
        </div>
      </div>
    );
  };

  const arrowComponent = () => {
    const onClickSameDetails = () => {
      setCreditUserUpdatedData({
        firstName: creditCardUserData.firstName,
        lastName: creditCardUserData.lastName,
        email: creditCardUserData.email,
        phoneNumber: creditCardUserData.phoneNumber,
        city: creditCardUserData.city,
        state: creditCardUserData.state,
        zipcode: creditCardUserData.zipcode,
        country: creditCardUserData.country,
        address: creditCardUserData.userAddress,
        amount: getAmount() || "",
      });
    };
    return (
      <div
        style={{
          marginTop: "auto",
          marginBottom: "auto",
        }}
        id="arrow"
      >
        <IconButton onClick={onClickSameDetails} sx={{ color: "#f05802" }}>
          <ArrowCircleRightOutlinedIcon className={styles.ArrowCircularIcon} />
        </IconButton>
      </div>
    );
  };

  const zipCodeApi = () => {
    if (creditCardUserUpdatedData.zipcode === "") {
      setErrorMessage({
        ...errorMessage,
        zipcode: "Please Enter Zipcode",
      });
    } else {
      apiRequest({
        method: "GET",
        endpoint: apiPath.cityAndStateApi,
        params: {
          zip: creditCardUserUpdatedData.zipcode,
        },
      })
        .then((res) => {
          setCreditUserUpdatedData({
            ...creditCardUserUpdatedData,
            state: res.data.stateName,
            city: res.data.city,
          });
        })
        .catch((err) => {
          setErrorMessage({
            ...errorMessage,
            zipcode: catchErrorMessageHandler(err),
          });
          setCreditUserUpdatedData({
            ...creditCardUserUpdatedData,
            state: "",
            city: "",
          });
        });
    }
  };

  const CreditCardUserUpdatedDetails = () => {
    const handleCreditCardChange = (field: string, value: any) => {
      setCreditUserUpdatedData({
        ...creditCardUserUpdatedData,
        [field]: value,
      });
    };

    return (
      <div
        style={{ padding: "10px 25px", gap: "8px" }}
        className={styles.detailsContainer}
      >
        {/* <CustomTooltip title={constants.MANAGER_CREDIT_CARD_TEXT_MESSAGE} placement="top-start" arrow>
          <Typography
            className={styles.deafult}
          >
            {constants.MANAGER_CREDIT_CARD_TEXT_MESSAGE.length > 45
              ? `${constants.MANAGER_CREDIT_CARD_TEXT_MESSAGE.slice(0, 45)}...`
              : constants.MANAGER_CREDIT_CARD_TEXT_MESSAGE}
          </Typography>
        </CustomTooltip> */}
        <Typography className={styles.deafult}>
          {constants.MANAGER_CREDIT_CARD_TEXT_MESSAGE}
        </Typography>
        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("First Name", true)}
          <CustomTextFeild
            id="first-name"
            fullWidth
            required
            placeholder="Enter First Name"
            value={creditCardUserUpdatedData.firstName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setErrorMessage({
                ...errorMessage,
                firstName: "",
              });
              const inputValue = e.target.value;
              // Limit input to 50 characters
              if (inputValue.length <= 50) {
                // Validate input to allow only alphabets
                if (/^[a-zA-Z]*$/.test(inputValue) || inputValue === "") {
                  handleCreditCardChange("firstName", inputValue);
                }
              }
            }}
            className={
              errorMessage.firstName ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.firstName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.firstName}
            </Typography>
          ) : (
            ""
          )}
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Last Name", true)}
          <CustomTextFeild
            id="last-name"
            fullWidth
            required
            placeholder="Enter Last Name"
            value={creditCardUserUpdatedData.lastName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setErrorMessage({
                ...errorMessage,
                lastName: "",
              });
              const inputValue = e.target.value;
              if (/^[a-zA-Z]*$/.test(inputValue) || inputValue === "") {
                handleCreditCardChange("lastName", inputValue);
              }
            }}
            className={
              errorMessage.lastName ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.lastName ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.lastName}
            </Typography>
          ) : (
            ""
          )}
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Address", true)}
          <CustomTextFeild
            id="address-edit"
            fullWidth
            required
            placeholder="Enter Address"
            value={creditCardUserUpdatedData.address}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const inputValue = e.target.value;
              if (inputValue.length <= 100) {
                setErrorMessage({
                  ...errorMessage,
                  address: "",
                });
                handleCreditCardChange("address", inputValue);
              }
            }}
            className={
              errorMessage.address ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.address && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.address}
            </Typography>
          )}
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Zip Code", true)}
          <CustomTextFeild
            id="zip-code"
            fullWidth
            required
            placeholder="Enter Zipcode"
            value={creditCardUserUpdatedData.zipcode}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setErrorMessage({ ...errorMessage, zipcode: "" });
              const inputValue = e.target.value;
              // Only allow numbers
              const sanitizedInput = inputValue
                .replace(/[^0-9]/g, "")
                .slice(0, 10);
              handleCreditCardChange("zipcode", sanitizedInput);
            }}
            onBlur={zipCodeApi}
            className={
              errorMessage.zipcode ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.zipcode ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.zipcode}
            </Typography>
          ) : (
            ""
          )}
        </div>
        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("City", true)}
          <CustomTextFeild
            id="cityEdit"
            fullWidth
            required
            value={creditCardUserUpdatedData.city}
            InputProps={{
              readOnly: true,
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setErrorMessage({ ...errorMessage, city: "" });
              handleCreditCardChange("city", e.target.value);
            }}
            className={
              errorMessage.city ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.city ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.city}
            </Typography>
          ) : (
            ""
          )}
        </div>
        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("State", true)}
          <CustomTextFeild
            id="stateEdit"
            fullWidth
            required
            value={creditCardUserUpdatedData.state}
            InputProps={{
              readOnly: true,
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setErrorMessage({ ...errorMessage, state: "" });
              handleCreditCardChange("state", e.target.value);
            }}
            className={
              errorMessage.state ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.state ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.state}
            </Typography>
          ) : (
            ""
          )}
        </div>

        <div className={styles.singleFeild}>
          {CustomRequiredInputLabel("Country", true)}
          <CustomTextFeild
            id="countryEdit"
            fullWidth
            required
            InputProps={{
              readOnly: false,
            }}
            placeholder="Enter Country"
            value={creditCardUserUpdatedData.country}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const inputValue = e.target.value;
              if (inputValue.length <= 100) {
                setErrorMessage({
                  ...errorMessage,
                  country: "",
                });
                handleCreditCardChange("country", inputValue);
              }
            }}
            className={
              errorMessage.country ? styles.errorTextField : styles.textField
            }
          />
          {errorMessage.country && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.country}
            </Typography>
          )}
        </div>
      </div>
    );
  };

  const userDetailsComponent = () => {
    return (
      <div className={styles.userDetailsContainer}>
        {CreditCardUserDetails()}
        {arrowComponent()}
        {CreditCardUserUpdatedDetails()}
      </div>
    );
  };

  const CreditCardConatiner = () => {
    return (
      <div className={styles.CreditCardContainer}>
        <Box className={styles.formContainer} sx={{ padding: "10px 25px" }}>
          <Typography
            style={{
              textAlign: "center",
              marginTop: "50px",
              fontWeight: "600",
            }}
          >
            {name}
          </Typography>
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Credit Card No", true)}
              <CustomTextFeild
                id="creditCardNumber"
                // className={styles.textField}
                inputRef={cardRef}
                sx={{ width: "100%", marginTop: "0px" }}
                type="tel"
                required
                onChange={debounce((e: ChangeEvent<HTMLInputElement>) => {
                  setErrorMessage({ ...errorMessage, creditCardNumber: "" });
                  parseCardDetails(e.target.value);
                })}
                // onKeyDown={(e:React.KeyboardEvent<HTMLInputElement>)=>parseCardDetails(e.currentTarget.value)}
                className={
                  errorMessage.creditCardNumber
                    ? styles.errorTextField
                    : styles.textField
                }
                // onBlur={cardTypeOnBlur}
                placeholder="Enter Credit Card Number"
              />

              {errorMessage.creditCardNumber ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.creditCardNumber}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Expiry Date", true)}
              {ExpiryDatePicker()}
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Credit Card Type", true)}
              {CreditCardTypeDropdown()}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("Amount", true)}
              <CustomTextFeild
                id="amount"
                className={styles.textField}
                // fullWidth
                required
                value={getAmount()}
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <AttachMoneyIcon
                        fontSize="small"
                        sx={{ zIndex: "1", position: "absolute" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid xs={12} sm={4} item>
              {CustomRequiredInputLabel("CVV", true)}
              <CustomTextFeild
                id="cvv"
                fullWidth
                required
                value={formData.cvv}
                type={cvvText ? "text" : "password"}
                onChange={(e) => {
                  setErrorMessage({ ...errorMessage, cvv: "" });
                  const numericInput = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 4);
                  handleFieldChange("cvv", numericInput);
                  setCVVtext(false);
                }}
                className={
                  errorMessage.cvv ? styles.errorTextField : styles.textField
                }
                placeholder="Enter CVV"
              />
              {errorMessage.cvv ? (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {errorMessage.cvv}
                </Typography>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Box>
      </div>
    );
  };

  const paymentComponent = () => {
    return (
      <>
        <Box className={styles.backArrow}>
          <div onClick={navigateBack} style={{ marginRight: "10px" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>
            Credit Card Information
          </Typography>
        </Box>
        <HcccCard
          sx={{
            gap: "40px",
            // marginTop: "40px",
            // padding: "24px",
          }}
        >
          <Box>{userDetailsComponent()}</Box>
          <hr style={{ background: "#EAEAEA" }} />
          <Box>{CreditCardConatiner()}</Box>
          <div style={{ marginTop: "20px", marginBottom: "24px" }}>
            {handleButtons()}
          </div>
        </HcccCard>
      </>
    );
  };

  return (
    <>
      <Toaster />
      {!showReceipt && !showSuccessComponent ? paymentComponent() : ""}
      <PaymentCancelConfirmationDialog isOpen={openPaymentCancelDialog} handleClose={handleClose} handleCancel={handleCancel}/>
    </>
  );
}
